import { Article } from '@/shared/components/article';
import { TextFade } from '@/shared/components/fade-text';
import { TextGradient } from '@/shared/components/text-gradient';
interface SpecificCaseProps {
  name: string;
  description: string;
}
export const Main = (props: SpecificCaseProps) => {
  const {
    name,
    description
  } = props;
  return <Article tag="main">
      <div className="flex-col items-center py-10 sm:flex">
        <TextGradient className="mb-2 text-center text-4xl xs:text-5xl sm:mb-6 md:text-7xl lg:text-8xl" tag="h1" text={name} />

        <TextFade text={description} tag="p" className="max-w-lg text-center text-muted-foreground lg:text-lg lg:leading-7" />
      </div>
    </Article>;
};